export const REQUEST_USERINGENERALPOOL_DATA = 'REQUEST_USERINGENERALPOOL_DATA';
export const USERINGENERALPOOL_DATA_RECEIVED = 'USERINGENERALPOOL_DATA_RECEIVED';